import {measureDef, unitMap} from "./base";


const apparentPower: unitMap = {
  VA: {
    name: {
      singular: 'Volt-Ampere',
      plural: 'Volt-Amperes',
    },
    to_anchor: 1,
  },
  mVA: {
    name: {
      singular: 'Millivolt-Ampere',
      plural: 'Millivolt-Amperes',
    },
    to_anchor: 0.001,
  },
  kVA: {
    name: {
      singular: 'Kilovolt-Ampere',
      plural: 'Kilovolt-Amperes',
    },
    to_anchor: 1000,
  },
  MVA: {
    name: {
      singular: 'Megavolt-Ampere',
      plural: 'Megavolt-Amperes',
    },
    to_anchor: 1000000,
  },
  GVA: {
    name: {
      singular: 'Gigavolt-Ampere',
      plural: 'Gigavolt-Amperes',
    },
    to_anchor: 1000000000,
  },
};
export const ApparentPowerDef:measureDef = {
  type:"apparentPower",
  metric: apparentPower,
  _anchors: {
    metric: {
      unit: 'VA',
      ratio: 1,
    },
  },
};
